export const isNullish = (value: any): boolean => value === undefined || value === null
export const isNotNullish = (value: any): boolean => !isNullish(value)
